import {invokeApi} from '@/resource/js/GLOBAL2'
const state = {
    bannerList:[],
    advBanner:[],
    enterList:[],
    indexBox:[]
}
const getters = {
};

const actions = {
    initSwiperBannerAdv({commit,state},param){
        return new Promise((resolve,reject)=>{
            invokeApi('/index/getScrollPicDetailList',{},'get',Math.random(),function (res) {
                commit('INIT_SWIPER_BANNER_ADV',res);
                resolve(res)
            })
        })
    }
};
let mutations = {
    INIT_SWIPER_BANNER_ADV(state,param){
        state.bannerList = param.banner;
        state.advBanner = param.ggw;
        state.enterList = param.ksrk;
        state.indexBox = param.kpt;
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/swiper_banner.js